import { useState, React } from "react";
import FormInput from "./FormInput";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { TbWorld } from "react-icons/tb";
import { MdOutlineEmail } from "react-icons/md";
import RegisterButton from "./buttons/RegisterButton";
import axios from "axios";
import { toast } from "react-hot-toast";
import { NavLink } from "react-router-dom";

export default function ContactSection() {
  const [contactFormData, setContactFormData] = useState({
    username: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  function handleChange(e) {
    const { name, value } = e.currentTarget;

    setContactFormData((prevContactFormState) => ({
      ...prevContactFormState,
      [name]: value,
    }));
  }

  function handleSubmit(event) {
    event.preventDefault();
    axios
      .post("/contact", {
        username: contactFormData.username,
        email: contactFormData.email,
        phone: contactFormData.phone,
        subject: contactFormData.subject,
        message: contactFormData.message,
      })
      .then(({ data }) => {
        if (data.error) {
          return toast.error(data.error);
        }
        return toast.success("contact send successfully");
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setContactFormData({
          username: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      });
  }

  return (
    <section className="contact_section">
      <h2>Contact Us</h2>
      <div className="contact_container">
        <form className="contact_form" onSubmit={handleSubmit}>
          <FormInput
            label="Full NAME"
            type="text"
            id="username"
            placeHolder="Ex. John Doe"
            onChange={handleChange}
            value={contactFormData.username}
          />
          <FormInput
            label="Email"
            type="text"
            id="email"
            placeHolder="Ex. johndoe@gmail.com"
            onChange={handleChange}
            value={contactFormData.email}
          />
          <FormInput
            label="Phone"
            type="text"
            id="phone"
            placeHolder="233xxxxxxxxxx"
            onChange={handleChange}
            value={contactFormData.phone}
          />
          <FormInput
            label="Subject"
            type="text"
            id="subject"
            placeHolder="Ex. Service"
            onChange={handleChange}
            value={contactFormData.subject}
          />
          <div className="form_input_container textarea">
            <label htmlFor="message">Message</label>
            <textarea
              name="message"
              id="message"
              placeholder="Ex. Hello. Admin how do I ...."
              onChange={handleChange}
              value={contactFormData.message}
            ></textarea>
          </div>

          <RegisterButton
            className={"btn submit"}
            value={"Submit"}
            onSubmit={handleSubmit}
          />
        </form>

        <div className="contact_detail">
          <h1 className="logo">
            <NavLink to="/home" className="main_logo">
              <img src="/logo.webp" alt="logo" className="logo_image" />
              {/* <h2>PayoutProphet</h2> */}
              <div className="logo_text">
                <span>Payout</span>
                <span>Prophet</span>
              </div>
            </NavLink>
          </h1>

          <p>
            PayoutProphet provides expert sports predictions and dedicated customer support. 
            For any questions about our services or technical assistance, contact our team. 
            We respond within 24 hours on business days. Remember, our predictions are for 
            entertainment purposes only—bet responsibly.
          </p>
          <article className="info">
            <p>
              <FaLocationDot /> <span>2 Walnut Street, East Legon Ghana</span>
            </p>
            <p>
              <FaPhoneAlt /> <a href="tel:233200664766">233 200 6647 66</a>
            </p>
            <p>
              <MdOutlineEmail /> <a href="mailto:info@payoutprophet.com">info@payoutprophet.com</a>
            </p>
            <p>
              <TbWorld /> <a href="home">payoutprophet.com</a>
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}
